import { registerBeginnerSerialMonitorBlocks as defineSerialMonitorBlocks } from './serial-monitor-blocks.js';

let registered = false;

export function registerBeginnerSerialMonitorBlocks(): void {
  if (registered) {
    return;
  }
  defineSerialMonitorBlocks();
  registered = true;
}
